import Backbone from 'backbone';

import EditorRoutes from 'foundation/EditorRoutes';
import getRouteManifest from 'routing/getRouteManifest';

class Router extends Backbone.Router {
  /**
   * Defines how urls map to functions that determine what the user can see and do at that url.
   * See https://backbonejs.org/#Router for details.
   * */

  static initClass(): void {
    // This is the mapping from url-patterns to handling functions.
    this.prototype.routes = getRouteManifest();
  }

  override initialize(): void {
    if (module.hot) {
      EditorRoutes.hotReload();
    }
  }
}
Router.initClass();

export default Router;
